import { render, staticRenderFns } from "./CollapseAreaPreservacaoPermanente.vue?vue&type=template&id=04db8cdd&scoped=true"
import script from "./CollapseAreaPreservacaoPermanente.vue?vue&type=script&lang=js"
export * from "./CollapseAreaPreservacaoPermanente.vue?vue&type=script&lang=js"
import style0 from "./CollapseAreaPreservacaoPermanente.vue?vue&type=style&index=0&id=04db8cdd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04db8cdd",
  null
  
)

export default component.exports